import { render, staticRenderFns } from "./dictionary_group_dialog.vue?vue&type=template&id=fa90c7b2"
import script from "./dictionary_group_dialog.vue?vue&type=script&lang=js"
export * from "./dictionary_group_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports